import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  variant: 'odds',
  fontWeight: 'normal',
};

export const buttonIncreaseProps: CSSObject = {
  variant: 'secondary',
  fontWeight: 'normal',
};

export const IncreaseAmountWrapper: CSSObject = {
  gap: '1',
  mb: '0',
};
